import { GeoJsonLayer } from "@deck.gl/layers";
import { FISH_FACILITIES_URL } from "../../services/pallas";
import FactoryIcon from "../../icons/factory.svg";

export type Facility = { properties: { name: string, type: string } }

export function useFacilitiesLayer(): GeoJsonLayer<Facility> {

  return new GeoJsonLayer({
    id: 'fish_facilities',
    data: FISH_FACILITIES_URL,
    pickable: true,
    autoHighlight: true,
    pointType: 'icon',
    getIcon: () => ({ id: "FactoryIcon", url: FactoryIcon, width: 128, height: 128 }),
    iconSizeMaxPixels: 40,
    // iconSizeMinPixels: 22,
    iconSizeUnits: "common",
    getIconSize: 0.6,
    // iconBillboard: false,
    highlightColor: [100, 100, 100, 180],
    getIconColor: [0, 0, 0, 255],
    parameters: {
      depthTest: false
    },
  });
}
